import { IEditUserState } from './editUserContext';
import { EditUserActionTypes, TEditUserAction } from './editUserActions';

export const editUserReducer = (state: IEditUserState, action: TEditUserAction): IEditUserState => {
	switch (action.type) {
		case EditUserActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditUserActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditUserActionTypes.SET_ALL_DATA:
			return {
				...state,
				filePath: action.payload.filePath,
				userID: action.payload.userID,
				name: action.payload.name,
				surName: action.payload.surName,
				email: action.payload.email,
				phoneNumber: action.payload.phoneNumber,
				selectedRole: action.payload.selectedRole,
				selectedCustomer: action.payload.selectedCustomer,
				selectedCustomers: action.payload.selectedCustomers,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
			};
		case EditUserActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case EditUserActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
				sourceUrlLocally: null,
			};
		case EditUserActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditUserActionTypes.CHANGE_SURNAME:
			return {
				...state,
				surName: action.payload.surName,
			};
		case EditUserActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case EditUserActionTypes.CHANGE_PHONE_NUMBER:
			return {
				...state,
				phoneNumber: action.payload.phoneNumber,
			};
		case EditUserActionTypes.SET_FETCHED_ROLES:
			return {
				...state,
				fetchedRoles: action.payload.roles,
			};
		case EditUserActionTypes.SET_ROLE:
			return {
				...state,
				selectedRole: action.payload.role,
				fetchedCustomers: [],
				selectedCustomer: null,
				selectedCustomers: [],
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case EditUserActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditUserActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.selectedCustomer,
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case EditUserActionTypes.SET_CUSTOMERS:
			return {
				...state,
				selectedCustomers: action.payload.selectedCustomers,
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case EditUserActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditUserActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.selectedRestaurants,
			};
		case EditUserActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditUserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditUserActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditUserActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				name: '',
				surName: '',
				email: '',
				phoneNumber: '',
				fetchedRoles: [],
				selectedRole: null,
				fetchedCustomers: [],
				selectedCustomer: null,
				selectedCustomers: [],
				fetchedRestaurants: [],
				selectedRestaurants: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
